<ng-template #popupTemplate>
  <div class="stadia-maps-popup-container">
    @if (displayClose()) {
      <pxw-icon
        icon="close"
        size="xxs"
        color="pink"
        class="ui-clickable stadia-maps-popup-close"
        (click)="hidePopup()"
      />
    }
    <div class="popup-content-wrapper">
      <ng-container *ngTemplateOutlet="popupContentTemplate()" />
    </div>
  </div>
</ng-template>
